import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, select } from 'redux-saga/effects';
import { userProfile } from 'redux/saga/entities/bound';
import { memberStatus as selectMemberStatus, isLoggedIn as selectIsLoggedIn } from 'redux/saga/selectors';
import { memberStatus as memberStatusEnum } from 'enums/memberStatus';

export function* memberHasStatus(client, memberStatus) {
  if (yield select(selectIsLoggedIn)) {
    yield call(fetchEntityIfNeeded, userProfile, [client]);
    return memberStatusEnum(memberStatus, yield select(selectMemberStatus));
  }

  return false;
}

export function* memberIsActive(client) {
  return yield call(memberHasStatus, client, 'ACTIVE');
}

export function* memberIsCartAbandoner(client) {
  return yield call(memberHasStatus, client, 'UNSUBSCRIBED');
}
